module.exports = __webpack_public_path__ + "static/media/completed.01a7b7df.svg";